import { render, staticRenderFns } from "./ConstructionTable.vue?vue&type=template&id=8f34c9aa&scoped=true&"
import script from "./ConstructionTable.vue?vue&type=script&lang=js&"
export * from "./ConstructionTable.vue?vue&type=script&lang=js&"
import style0 from "./ConstructionTable.vue?vue&type=style&index=0&id=8f34c9aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f34c9aa",
  null
  
)

export default component.exports